module.exports = __webpack_public_path__ + "assets/badge-module-4.65cb24cd6e86d31526604f7066461882.svg";